export default [
    {
        step: 1,
        name: 'StafetDeltagPaaHoldStepOne',
        completed: false,
        label: 'formStepLabel1',
        hidden: false
    },
    {
        step: 2,
        name: 'StafetDeltagPaaHoldStepTwo',
        completed: false,
        label: 'formStepLabel2',
        hidden: false
    },
    {
        step: 3,
        name: 'StafetDeltagPaaHoldStepThree',
        completed: false,
        label: 'formStepLabel3',
        hidden: false
    },
    {
        step: 4,
        name: 'StafetDeltagPaaHoldStepFour',
        completed: false,
        label: 'formStepLabel4',
        hidden: false
    },
    {
        step: 5,
        name: 'FormStepSubmitting',
        completed: false,
        label: '',
        hidden: true
    }
]
